import script from "./software-activity-trend-chart.vue?vue&type=script&lang=ts&setup=true"
export * from "./software-activity-trend-chart.vue?vue&type=script&lang=ts&setup=true"

import "./software-activity-trend-chart.vue?vue&type=style&index=0&id=0d55a3a4&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d55a3a4"]])

export default __exports__